"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _ConfirmAPIKeyModal = _interopRequireDefault(require("../ConfirmApiKeyModal/ConfirmAPIKeyModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NewApiKeyModal = function NewApiKeyModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: props.isOpen,
    title: t("Create New API Key"),
    customClass: "retail-api-keys-modal",
    onCancel: function onCancel() {
      props.removeApiKey(props.apiKey.APIKey);
      props.close();
    },
    close: props.close,
    footer: {
      buttonText: t("Confirm"),
      buttonStyle: 'additive',
      onClick: function onClick() {
        return props.addApiKey(props.apiKey);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_ConfirmAPIKeyModal["default"], {
    item: props.apiKey,
    userId: props.userId,
    index: props.numberOfApiKeys
  }));
};
NewApiKeyModal.propTypes = {
  apiKey: _propTypes["default"].object,
  userId: _propTypes["default"].number.isRequired,
  numberOfApiKeys: _propTypes["default"].number.isRequired,
  addApiKey: _propTypes["default"].func.isRequired,
  removeApiKey: _propTypes["default"].func.isRequired,
  close: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = NewApiKeyModal;